import styled from "styled-components"

import SendVerifyEmailSvg from "./send-verify-email.svg"

const SendVerifyEmailImage = styled(SendVerifyEmailSvg)`
  max-width: 400px;
  width: 100%;
  min-height: 340px;
  height: 100%;
`

export default SendVerifyEmailImage
